import React, { useEffect, useMemo, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from 'reactstrap';
import classNames from 'classnames';

import SmsTab from './TabsModel/SmsTab';
import WhatsAppTab from './TabsModel/whatsApptab';
import EmailTab from './TabsModel/EmailTab';
import AiVoiceTab from './TabsModel/AiVoiceTab';
import { AxiosAPI, getGroupID } from './../../../../../../../helpers/AxiosAPI';
import { gAPI_GuestMessagingReservation_CountByStatus } from './../../../../../../../constants/APIs';
import { useSelector } from 'react-redux';

export default function SendMessagePanel({
  activeTab = 'sms',
  onClose,
  preFillPhoneNumber,
  propertyId,
  showStatusFilter = false,
  showEligibleCount = false,
  eligibleCount = 0,
  eligibleCountLabel = 'Eligible Members',
  showPhoneNumber = false,
  reservationId,
  source,
  allowedTabs,
  disableSubmit = false,
  disabledSubmitMessage = '',
  reservationData,
  showTabs = true,
  showTitle = true,
  recipientId,
  marketingConsent,
  setMarketingConsent,
}) {
  const { timeZone } = useSelector(({ settings }) => ({
    timeZone: settings.timeZone,
  }));

  const [currentTab, setCurrentTab] = useState(activeTab);

  const [totalCount, setTotalCount] = useState(0);
  const [countLoading, setCountLoading] = useState(false);
  const tabs = useMemo(
    () => allowedTabs || ['sms', 'whatsapp', 'aivoice'],
    [allowedTabs]
  );

  // when icon is clicked again, switch tab
  useEffect(() => {
    setCurrentTab(activeTab);
  }, [activeTab]);

  useEffect(() => {
    if (!tabs.includes(currentTab)) {
      setCurrentTab(tabs[0] || 'sms');
    }
  }, [currentTab, tabs]);

  const fetchCountByStatus = async (status, channel) => {
    if (!status || !propertyId) return;

    try {
      setCountLoading(true);

      const res = await AxiosAPI({
        method: 'get',
        url:
          `${gAPI_GuestMessagingReservation_CountByStatus}` +
          `?propertyId=${propertyId}` +
          `&groupId=${getGroupID()}` +
          `&reservationStatus=${status}` +
          `&channel=${channel}` +
          `&timeZone=${timeZone}`,
      });

      setTotalCount(res.data?.totalCount || 0);
    } catch (e) {
      console.error('count-by-status error', e);
      setTotalCount(0);
    } finally {
      setCountLoading(false);
    }
  };

  return (
    <Modal
      isOpen
      toggle={onClose}
      wrapClassName="modal-right"
      backdrop="static"
    >
      <ModalHeader toggle={onClose} style={{ padding: '25.1px' }}>
        {showTitle ? 'Send Message' : ''}
      </ModalHeader>

      <ModalBody className={showTabs ? 'py-2' : 'p-2'}>
        {/* Tabs header */}
        {showTabs && (
          <Nav tabs>
            {tabs.includes('sms') && (
              <NavItem>
                <NavLink
                  className={classNames({ active: currentTab === 'sms' })}
                  onClick={() => setCurrentTab('sms')}
                  style={{ cursor: 'pointer' }}
                >
                  SMS
                </NavLink>
              </NavItem>
            )}

            {tabs.includes('whatsapp') && (
              <NavItem>
                <NavLink
                  className={classNames({ active: currentTab === 'whatsapp' })}
                  onClick={() => setCurrentTab('whatsapp')}
                  style={{ cursor: 'pointer' }}
                >
                  WhatsApp
                </NavLink>
              </NavItem>
            )}
            {tabs.includes('aivoice') && (
              <NavItem>
                <NavLink
                  className={classNames({ active: currentTab === 'aivoice' })}
                  onClick={() => setCurrentTab('aivoice')}
                  style={{ cursor: 'pointer' }}
                >
                  Voice Call
                </NavLink>
              </NavItem>
            )}

            {/* <NavItem>
            <NavLink
              className={classNames({ active: currentTab === 'email' })}
              onClick={() => setCurrentTab('email')}
              style={{ cursor: 'pointer' }}
            >
              Email
            </NavLink>
          </NavItem> */}
          </Nav>
        )}

        {/* Tabs content */}
        <TabContent activeTab={currentTab}>
          <TabPane tabId="sms">
            <SmsTab
              preFillPhoneNumber={preFillPhoneNumber || ''}
              propertyId={propertyId}
              showStatusFilter={showStatusFilter}
              showPhoneNumber={showPhoneNumber}
              reservationId={reservationId}
              source={source}
              totalCount={totalCount}
              loadingCount={countLoading}
              showEligibleCount={showEligibleCount}
              eligibleCount={eligibleCount}
              eligibleCountLabel={eligibleCountLabel}
              disableSubmit={disableSubmit}
              disabledSubmitMessage={disabledSubmitMessage}
              recipientId={recipientId}
              onStatusChange={(status) => {
                fetchCountByStatus(status, 'SMS');
              }}
              reservationData={reservationData}
              marketingConsent={marketingConsent}
              setMarketingConsent={setMarketingConsent}
            />
          </TabPane>

          <TabPane tabId="whatsapp">
            <WhatsAppTab
              preFillPhoneNumber={preFillPhoneNumber || ''}
              propertyId={propertyId}
              recipientId={recipientId}
              showStatusFilter={showStatusFilter}
              showPhoneNumber={showPhoneNumber}
              reservationId={reservationId}
              source={source}
              totalCount={totalCount}
              loadingCount={countLoading}
              showEligibleCount={showEligibleCount}
              eligibleCount={eligibleCount}
              eligibleCountLabel={eligibleCountLabel}
              disableSubmit={disableSubmit}
              disabledSubmitMessage={disabledSubmitMessage}
              onStatusChange={(status) => {
                fetchCountByStatus(status, 'Whatsapp');
              }}
              reservationData={reservationData}
              marketingConsent={marketingConsent}
              setMarketingConsent={setMarketingConsent}
            />
          </TabPane>
          <TabPane tabId="aivoice">
            <AiVoiceTab
              preFillPhoneNumber={preFillPhoneNumber || ''}
              propertyId={propertyId}
              showStatusFilter={showStatusFilter}
              showPhoneNumber={showPhoneNumber}
              reservationId={reservationId}
              source={source}
              totalCount={totalCount}
              loadingCount={countLoading}
              onStatusChange={(status) => {
                fetchCountByStatus(status, 'PhoneSuite');
              }}
              reservationData={reservationData}
            />
          </TabPane>

          {/* <TabPane tabId="email">
            <EmailTab
            propertyId={propertyId}
             />
          </TabPane> */}
        </TabContent>
      </ModalBody>
    </Modal>
  );
}
